import axios from 'axios';

async function GenerarCredencial(prmNroDocumento: string) {
    
    const url = "https://credenciales.mapsys.com.ar/api/credvirtAPI.php"
    
    try {
        const response = await axios.post(url, {
            "origen": "credvirtApp",
            "clave": "5384b83e7d07f6e21b4ce44cd9249053bbf18d3b83f969e33d1ecd23db815531d2041fc1e6df4905de1f7068597d35161de6026692aa88d9c8eaed0401869bd7",
            "usuarioseguro": "0f12699028842d91b09814544dc1d5e75c83373272554aad4fa160a5c6a7c471858c1dea0a642343506b32f4f70d9b88e2e705205495eb20904fb63e3d7bb03b",
            "usuario": "vidaplus",
            "accion": "credencialGenerar",
            "servicio": "1",
            "dni": prmNroDocumento        
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GenerarCredencial;